import React from 'react';
import './AboutMe.css';

export default function AboutMe() {
  const qualities = [
    "Driven",
    "Enthusiastic",
    "Versatile",
    "Empathetic",
    "Lifelong-learner",
    "Optimistic",
    "Persistent",
    "Experimental",
    "Resilient"
  ];

  return (
    <section className="about-me-section-wrapper">
      {/* Grain overlay — same as Profile */}
      <div className="grain" aria-hidden="true" />

      {/* Section label — ties visually to Profile typography rhythm */}
      <div className="section-label">About me</div>

      <div className="about-me-container">
        {/* Left: DEVELOPER acrostic */}
        <div className="developer-qualities">
          {qualities.map((quality, index) => (
            <div key={index} className="quality-line">
              <span className="first-letter">{quality[0]}</span>
              <span className="remaining-letters">{quality.slice(1)}</span>
            </div>
          ))}
        </div>

        {/* Right: main content card */}
        <div className="about-me-details-container">
          <div className="about-me-details">
            <h2>WHO AM I ?</h2>
            <p className="full-name">I'm Fenofifaliana RAFANOMEZANTSOA</p>
            <p style={{textAlign: "center"}}>
              <span className="text-bg">A developer passionate about</span>
              <span className="dev-container">[web, software]</span>
              <span className="text-bg">
                development.
              </span>
            </p>
            <p> Continuously eager to grow my skill set, I'm also deeply curious about the evolving digital landscape and how businesses innovate and adapt in a fast-paced world.</p>
          </div>
        </div>
      </div>
    </section>
  );
}